import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ['nav'];
  static values = {
    isOpen: { default: false, type: Boolean }
  }

  isOpenValueChanged(isOpen) {
    if (isOpen) {
      this.navTarget.classList.add('h-[9.125rem');
      this.navTarget.classList.remove('h-0');
    } else {
      this.navTarget.classList.remove('h-[9.125]');
      this.navTarget.classList.add('h-0');
    }
  }

  toggle() {
    this.isOpenValue = !this.isOpenValue;
  }

  close() {
    this.isOpenValue = false;
  }
}
